export default {
  data() {
    return {
      isChecked: false,
    };
  },
  methods: {
    handleToggle(checked) {
      this.isChecked = checked;
    }
  },
};
